export class PagedListCache<T> {
  public page: number;
  public total: number;
  public pages: Array<Array<T>>;

  constructor() {
    this.page = 0;
    this.total = 0;
    this.pages = [];
  }

  public count() {
    return this.pages.reduce((acc, page) => acc + page.length, 0);
  }

  public reset() {
    this.page = 0;
    this.total = 0;
    this.pages = [];
  }
}
